export const useModalStore = defineStore('modal', () => {
    const isDialogVerifyProfile = ref(false)
    const isDialogCompleteProfile = ref(false)
    const isNewsletterSuccessModal = ref(false)

    return { isDialogVerifyProfile, isDialogCompleteProfile, isNewsletterSuccessModal }
})
